import * as $ from 'jquery';

export default class CookieHandler {

    /**
     * get cookie by name
     */
    getCookieByName(name) {
        var cookies = document.cookie.split(';');

        for (var i = 0; i < cookies.length; i++) {
            var c = cookies[i].trim();
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) != -1) {
                return c.substring(name.length + 1, c.length);
            }
        }
        return false;
    }
}